/**
 * Политика возврата
 * /refund
 */

import { useNavigate } from 'react-router-dom';

export function RefundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F7F4] text-[#252A2D] p-4">
      <div className="max-w-2xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="px-3 py-1.5 bg-white border border-[#E1E5E3] hover:bg-white border border-[#E1E5E3] rounded-lg text-sm transition-all mb-6"
        >
          ← Назад
        </button>

        <h1 className="text-2xl font-bold mb-6 text-center">💰 Политика возврата</h1>

        <div className="bg-white border border-[#E1E5E3] rounded-2xl p-6 space-y-6 text-[#626B73] text-sm leading-relaxed">
          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Общие положения</h2>
            <p>
              Настоящая политика возврата распространяется на все покупки, совершённые 
              на платформе BESHEK (<a href="https://beshek.mugstel.ru" className="text-purple-400 hover:underline">beshek.mugstel.ru</a>).
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Цифровые товары</h2>
            <p>
              Все курсы, уроки и образовательные материалы на платформе являются 
              <strong className="text-[#252A2D]"> цифровыми товарами</strong>, доступ к которым 
              предоставляется мгновенно после оплаты.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Условия возврата</h2>
            <div className="bg-red-500/20 border border-red-500/50 rounded-xl p-4 mt-2">
              <p className="text-red-200">
                <strong>⚠️ Возврат денежных средств не производится</strong>
              </p>
              <p className="mt-2 text-red-300 text-xs">
                В соответствии со статьёй 26.1 Закона РФ «О защите прав потребителей», 
                потребитель не вправе отказаться от товара надлежащего качества, 
                если он имеет индивидуально-определённые свойства и может быть использован 
                исключительно приобретающим его потребителем. Цифровые образовательные 
                материалы относятся к такой категории товаров.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Исключения</h2>
            <p>
              Возврат возможен в следующих случаях:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-2">
              <li>
                <strong className="text-[#252A2D]">Техническая ошибка оплаты</strong> — 
                двойное списание, ошибка платёжной системы
              </li>
              <li>
                <strong className="text-[#252A2D]">Неполучение доступа</strong> — 
                если после оплаты доступ к материалам не был предоставлен по вине платформы
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Как запросить возврат</h2>
            <p>
              Если вы считаете, что имеете право на возврат, свяжитесь с нами:
            </p>
            <div className="bg-white border border-[#E1E5E3] rounded-xl p-4 mt-2">
              <p>📧 Email: <a href="mailto:qrulev@yandex.ru" className="text-purple-400 hover:underline">qrulev@yandex.ru</a></p>
              <p className="mt-1">💬 Или через <a href="/support" className="text-purple-400 hover:underline">форму поддержки</a></p>
            </div>
            <p className="mt-3">
              В обращении укажите:
            </p>
            <ul className="list-disc list-inside mt-1 space-y-1">
              <li>Email, использованный при оплате</li>
              <li>Дату и сумму платежа</li>
              <li>Причину запроса возврата</li>
            </ul>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Срок рассмотрения</h2>
            <p>
              Обращения рассматриваются в течение 5 рабочих дней. 
              В случае положительного решения возврат осуществляется тем же способом, 
              которым была произведена оплата, в течение 10 рабочих дней.
            </p>
          </section>

          <section>
            <h2 className="text-[#252A2D] font-bold mb-2">Рекомендация</h2>
            <div className="bg-[#0F766E]/20 border border-[#0F766E]/50 rounded-xl p-4">
              <p className="text-blue-200">
                💡 Перед покупкой рекомендуем ознакомиться с бесплатными уроками курса, 
                чтобы убедиться, что материал соответствует вашим ожиданиям.
              </p>
            </div>
          </section>

          <p className="text-purple-400 text-xs mt-6">
            Дата публикации: {new Date().toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
}